import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type LayoutProps = {
  noPad?: boolean;
  bgColor?: string;
  children: ReactNode;
};

const PageLayout = ({ bgColor = 'bg-white', noPad = false, children }: LayoutProps) => {
  return (
    <div className={cn(`min-h-screen ${bgColor} pt-8 flex justify-center`, noPad ? 'p-0' : 'p-6')}>
      <div className="w-full mx-auto space-y-6">
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
